(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-inquiry"] && !Shopify.designMode) return;
  try {
    class ProductInquiry extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const target = this.closest('.shopify-section, dialog, product-card');
      const options = { signal: this.controller.signal };
      target?.addEventListener('variant:selected', () => this.setPending(true), options);
      target?.addEventListener('variant:update', (event) => {
        const data = event.detail?.data;
        if (String(data?.productId) !== this.dataset.productId && !data?.newProduct) return;
        const source = data?.html?.getElementById(this.id);
        const context = this.querySelector('[data-inquiry-context]');
        const nextContext = source?.querySelector('[data-inquiry-context]');
        if (context && nextContext) context.replaceChildren(...nextContext.cloneNode(true).childNodes);
        // Only product context changes; preserve the customer's typed contact details.
        this.setPending(!event.detail.resource || !nextContext);
      }, options);
    }

    setPending(pending) {
      const submit = this.querySelector('[data-inquiry-submit]');
      const notice = this.querySelector('[data-inquiry-unavailable]');
      if (submit) submit.disabled = pending;
      if (notice) notice.hidden = !pending;
    }

    disconnectedCallback() { this.controller?.abort(); }
  }

  if (!customElements.get('product-inquiry')) customElements.define('product-inquiry', ProductInquiry);
  } catch(e) { console.error(e); }
})();

})();
